<template>
  <div id="welcome" />
</template>

<style lang="scss" scoped>
#welcome {
  width: 80%;
  margin: auto;
}

h1 {
  text-align: center;
}

p {
  text-align: center;
}
</style>
